module.exports = __webpack_public_path__ + "img/settings.fe98527d.jpg";